// Core
import { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Flex,
  Text,
  Grid,
  Divider,
  Image,
  useColorModeValue,
  useColorMode,
} from '@chakra-ui/react';
import { NavLink, Link } from 'react-router-dom';

// Components
import { StarsIcon, ArrowDiscountIcon } from 'components/Icons/Icons';
import Banners from 'components/Sliders/Banners';
import Categories from './components/Categories';
import Affiliate from './components/Affiliate';
import Partners from '../Partners';

const Discounts = ({ userData }) => {
  const textColorViewAllButton = useColorModeValue('#262D47', '#9FABCB');

  const { colorMode } = useColorMode();
  const isDark = colorMode === 'dark';

  const [featuredPartnersIsHidden, setFeaturedPartnersIsHidden] = useState(
    true
  );
  const [salePartnersIsHidden, setSalePartnersIsHidden] = useState(true);
  const [nearMePartnersIsHidden, setNearMePartnersIsHidden] = useState(true);

  const [userCoords, setUserCoords] = useState({ lat: 0, long: 0 });
  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setUserCoords({
          lat: pos.coords.latitude,
          long: pos.coords.longitude,
        });
      },
      () => {
        setUserCoords({ lat: 0, long: 0 });
      }
    );
  }, []);

  return (
    <>
      <Banners type="regular" objectType="partner" />
      <Box mt="55px" />

      <Categories />

      {/*<Affiliate />*/}

      {!featuredPartnersIsHidden && (
        <Flex
          justifyContent="space-between"
          alignItems="center"
          mt={{ base: '36px', md: '49px' }}
          mb="32px"
        >
          <Text
            as="h4"
            variant="header"
            fontSize={{ base: '24px', md: '32px' }}
            fontStyle="normal"
          >
            Featured
          </Text>
          <NavLink to="/discounts/partners?tops=featured">
            <Button
              variant="secondary-md"
              w="144px"
              color={textColorViewAllButton}
              fontWeight="500"
              borderRadius="full"
            >
              VIEW ALL <ArrowDiscountIcon fontSize="24px" />
            </Button>
          </NavLink>
        </Flex>
      )}
      <Partners
        partnersIsHidden={featuredPartnersIsHidden}
        setPartnersIsHidden={setFeaturedPartnersIsHidden}
        userData={userData}
        type="partner"
        tops="featured"
        limit={6}
      />

      {!nearMePartnersIsHidden && (
        <Flex
          justifyContent="space-between"
          alignItems="center"
          mt={{ base: '60px', md: '73px' }}
          mb="32px"
        >
          <Text
            as="h4"
            variant="header"
            fontSize={{ base: '24px', md: '32px' }}
            fontStyle="normal"
          >
            Savings Near You
          </Text>
          <NavLink to="/discounts/partners?nearMe=true">
            <Button
              variant="secondary-md"
              w="144px"
              color={textColorViewAllButton}
              fontWeight="500"
              borderRadius="full"
            >
              VIEW ALL <ArrowDiscountIcon fontSize="24px" />
            </Button>
          </NavLink>
        </Flex>
      )}
      <Partners
        partnersIsHidden={nearMePartnersIsHidden}
        setPartnersIsHidden={setNearMePartnersIsHidden}
        userData={userData}
        type="partner"
        nearMe={true}
        userCoords={userCoords}
        limit={6}
      />

      <Box
        textAlign="center"
        mb={{ base: '24px', md: '36px' }}
        mt={{ base: '60px', md: '84px' }}
      >
        <Flex
          display={{ base: 'none', md: 'flex' }}
          gap="12px"
          pl="26px"
          m="16px 0 17px 0"
          w="100%"
          justifyContent="center"
        >
          <StarsIcon fontSize="32px" mt="9px" />
          <Box borderRadius="16px" p="6px 16px" mt="-6px" background="white">
            <Box className="abstract-grad" mt="0px" left="10%" />
            <Text variant="header-gradient" fontSize="48px">
              Most Popular
            </Text>
          </Box>
          <Box position="relative">
            <Text variant="header-gradient" fontSize="48px">
              Savings
            </Text>
            <Box className="abstract-grad" mt="0px" right="0px" />
          </Box>
          <StarsIcon fontSize="32px" mt="9px" />
        </Flex>

        <Flex
          display={{ base: 'flex', md: 'none' }}
          gap="12px"
          m="16px 0 8px 0"
          w="100%"
          justifyContent="center"
        >
          <StarsIcon fontSize="32px" mt="9px" />
          <Box borderRadius="16px" p="6px 16px" mt="-6px" background="white">
            {isDark && <Box className="abstract-grad" mt="0px" left="10%" />}
            <Text variant="header-gradient" fontSize="36px">
              Most Popular
            </Text>
          </Box>
          <StarsIcon fontSize="32px" mt="9px" />
        </Flex>

        <Box
          display={{ base: 'block', md: 'none' }}
          position="relative"
          textAlign="center"
        >
          <Text variant="header-gradient" fontSize="36px">
            Savings
          </Text>
          {isDark && <Box className="abstract-grad" mt="0px" right="0px" />}
        </Box>

        <Text variant="header" fontSize={{ base: '24px', md: '32px' }}>
          Selected options to help you spend less
        </Text>
      </Box>
      <Partners userData={userData} type="partner" sort="mostPop" limit={5} />

      {!salePartnersIsHidden && (
        <Flex
          justifyContent="space-between"
          alignItems="center"
          mt={{ base: '60px', md: '73px' }}
          mb="32px"
        >
          <Text
            as="h4"
            variant="header"
            fontSize={{ base: '24px', md: '32px' }}
            fontStyle="normal"
          >
            Biggest Savings
          </Text>
          <NavLink to="/discounts/partners?sort=saleDesc">
            <Button
              variant="secondary-md"
              w="144px"
              color={textColorViewAllButton}
              fontWeight="500"
              borderRadius="full"
            >
              VIEW ALL <ArrowDiscountIcon fontSize="24px" />
            </Button>
          </NavLink>
        </Flex>
      )}
      <Partners
        partnersIsHidden={salePartnersIsHidden}
        setPartnersIsHidden={setSalePartnersIsHidden}
        userData={userData}
        type="partner"
        sort="saleDesc"
        limit={6}
      />

      <Flex
        justifyContent="space-between"
        alignItems="center"
        mt={{ base: '60px', md: '73px' }}
        mb="32px"
      >
        <Text
          as="h4"
          variant="header"
          fontSize={{ base: '24px', md: '32px' }}
          fontStyle="normal"
        >
          Featured Store
        </Text>
        <NavLink to="/discounts/partners?shop=true">
          <Button
            variant="secondary-md"
            w="144px"
            color={textColorViewAllButton}
            fontWeight="500"
            borderRadius="full"
          >
            VIEW ALL <ArrowDiscountIcon fontSize="24px" />
          </Button>
        </NavLink>
      </Flex>
      <Partners
        userData={userData}
        isGrid={true}
        type="partner"
        isStores={true}
        tops="shop"
        limit={6}
      />

      <Flex
        justifyContent="space-between"
        alignItems="center"
        mt={{ base: '60px', md: '71px' }}
        mb="32px"
      >
        <Text
          as="h4"
          variant="header"
          fontSize={{ base: '24px', md: '32px' }}
          fontStyle="normal"
        >
          AFFILIATE Partners
        </Text>
        <NavLink to="/discounts/affiliate-partners">
          <Button
            variant="secondary-md"
            w="144px"
            color={textColorViewAllButton}
            fontWeight="500"
            borderRadius="full"
          >
            VIEW ALL <ArrowDiscountIcon fontSize="24px" />
          </Button>
        </NavLink>
      </Flex>
      <Partners userData={userData} type="affiliate-partner" limit={6} />

      <Box mt="80px" />
    </>
  );
};

export default Discounts;
